import { Bar, BarChart, ResponsiveContainer, XAxis } from "recharts";

import { TimeofDayUsage } from "@shared/report";

interface TimeOfDayUsageChartProps {
  usage: TimeofDayUsage | null;
  darkMode: boolean;
  animationBegin?: number;
}

export function TimeOfDayUsageChart({
  usage,
  darkMode,
  animationBegin = 0,
}: TimeOfDayUsageChartProps) {
  if (!usage) return null;

  const rotated = [...usage.labeled.slice(6), ...usage.labeled.slice(0, 6)];

  const chartData = rotated.map(([label, dates]) => ({
    hour: label,
    count: dates.length,
  }));

  const lateNightPct = (usage.lateTimes.length / usage.times.length) * 100;

  return (
    <div
      className="px-4 pt-3 pb-2 mb-6 border border-neutral-200 dark:border-neutral-700
                 rounded-xl shadow-lg shadow-neutral-100 dark:shadow-black/30 overflow-hidden"
    >
      <span className="block uppercase text-xs font-bold mb-4">Time of Day Usage</span>
      <ResponsiveContainer width="100%" height={80}>
        <BarChart data={chartData} tabIndex={-1}>
          <XAxis
            dataKey="hour"
            axisLine={false}
            tickLine={false}
            tick={{
              fontSize: 11,
              fill: darkMode ? "var(--color-neutral-400)" : "var(--color-neutral-500)",
            }}
            interval={2}
          />
          <Bar
            dataKey="count"
            fill="var(--color-blue-500)"
            radius={[3, 3, 0, 0]}
            animationBegin={animationBegin}
            animationDuration={400}
            animationEasing="ease-in-out"
          />
        </BarChart>
      </ResponsiveContainer>
      <div className="px-2 py-1 text-sm bg-purple-100 -mx-4 -mb-2 text-purple-800 dark:bg-purple-950/50 dark:text-purple-100">
        Your late night usage percentage is{" "}
        <span className="font-bold">{Math.round(lateNightPct)}%</span>.
      </div>
    </div>
  );
}
